import * as THREE from "three";
import * as BufferGeometryUtils from "three/addons/utils/BufferGeometryUtils.js";

const ringThickness = 0.4; //0.2;
const arrowCenterThickness = 0.4; // 0.05
const ringRadius = 10;

function drawMoveRotateGroup(toothMesh, orthoViewer, center) {
  let group = null;
  // if (!center) center = toothMesh.position;
  if (toothMesh && toothMesh.moveRotateGroup) {
    group = toothMesh.moveRotateGroup;
  } else {
    group = new THREE.Group();

    const geometry = new THREE.SphereGeometry(
      // ringRadius + ringThickness * 2,
      20,
      32,
      16
    );
    const material = new THREE.MeshBasicMaterial({
      color: 0xff0000,
      transparent: true,
      depthWrite: false,
      side: THREE.DoubleSide,
      opacity: 0.0001, //0.2, 0.0001,
    });
    const sphere = new THREE.Mesh(geometry, material);
    group.add(sphere);

    const greenRing = createRing(0x00ff00, 0);
    greenRing.tag = "zRotateRing";
    greenRing.defaultColor = 0x00ff00;
    group.add(greenRing);

    const blueRing = createRing(0x0000ff, Math.PI / 2);
    blueRing.tag = "yRotateRing";
    blueRing.defaultColor = 0x0000ff;
    group.add(blueRing);

    const redRing = createRing(0xff0000, 0, Math.PI / 2);
    redRing.tag = "xRotateRing";
    redRing.defaultColor = 0xff0000;
    group.add(redRing);

    const blueArrow = createArrow(0x0000ff);
    blueArrow.tag = "yMoveArrow";
    blueArrow.defaultColor = 0x0000ff;
    group.add(blueArrow);

    const greenArrow = createArrow(0x00ff00, Math.PI / 2);
    greenArrow.tag = "zMoveArrow";
    greenArrow.defaultColor = 0x00ff00;
    group.add(greenArrow);

    const redArrow = createArrow(0xff0000, 0, 0, Math.PI / 2);
    redArrow.tag = "xMoveArrow";
    redArrow.defaultColor = 0xff0000;
    group.add(redArrow);

    group.position.copy(center); //.set(center.x, center.y, center.z)
    group.tag = "group";
    group.ringRadius = ringRadius;
    group.ringLength = 2 * Math.PI * ringRadius;
  }

  if (toothMesh) {
    toothMesh.moveRotateGroup = group;
    toothMesh.subvector = toothMesh.moveRotateGroup.position
      .clone()
      .sub(toothMesh.position);
  }

  orthoViewer.scene.add(group);
  return group;
}

function createArrow(color, radiansX, radiansY, radiansZ) {
  const coneTopGeometry = new THREE.ConeGeometry(2, 2, 32);
  coneTopGeometry.translate(0, 17, 0);
  const coneBottomGeometry = new THREE.ConeGeometry(2, 2, 32);
  coneBottomGeometry.rotateX(Math.PI);
  coneBottomGeometry.translate(0, -17, 0);
  const cylTopGeometry = new THREE.CylinderGeometry(1, 1, 2, 32);
  cylTopGeometry.translate(0, 15, 0);
  const cylBottomGeometry = new THREE.CylinderGeometry(1, 1, 2, 32);
  cylBottomGeometry.translate(0, -15, 0);

  const cylCenterGeometry = new THREE.CylinderGeometry(
    arrowCenterThickness,
    arrowCenterThickness,
    30,
    32
  );
  const geometries = [
    coneTopGeometry,
    coneBottomGeometry,
    cylTopGeometry,
    cylBottomGeometry,
    cylCenterGeometry,
  ];

  const geometry = BufferGeometryUtils.mergeGeometries(geometries);
  if (radiansX) geometry.rotateX(radiansX);
  if (radiansY) geometry.rotateY(radiansY);
  if (radiansZ) geometry.rotateZ(radiansZ);

  var mesh = new THREE.Mesh(
    geometry,
    new THREE.MeshPhongMaterial({
      color: color,
    })
  );
  return mesh;
}

function createRing(color, radiansX, radiansY, radiansZ) {
  // const geometry = new THREE.LatheGeometry(points);
  const geometry = new THREE.TorusGeometry(ringRadius, ringThickness, 16, 50);
  if (radiansX) geometry.rotateX(radiansX);
  if (radiansY) geometry.rotateY(radiansY);
  if (radiansZ) geometry.rotateZ(radiansZ);

  var mesh = new THREE.Mesh(
    geometry,
    new THREE.MeshPhongMaterial({
      color: color,
      // flatShading: false,
      // specular: 0x050505,
      // shininess: 200,
      // side: 2,
      // toneMapped: false,
      // depthWrite: false,
      // depthTest: false,
      // transparent: true,
    })
    // new THREE.MeshBasicMaterial({
    //   color: 0xff0000,
    // })
  );
  // mesh.position.y = 150;
  // mesh.overdraw = true;
  // mesh.doubleSided = true;
  return mesh;
}

export { drawMoveRotateGroup };
